import dynamic from 'next/dynamic';

export { default } from './ItemRequest';
export const LazyItemRequest = dynamic(() => import('./ItemRequest'), { ssr: false });
